import SwiperCore, { Navigation, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, EffectFade]);
import Swiper from 'swiper';

(function($) {
  $(function() {
    $('.text-slider__swiper').each(function() {
      var $slider = $(this);

      var swiper = new Swiper($slider.get(0), {
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 700
      });

      updateCaptionsHeight($slider);
      $(window).resize(debounce(function() {
        updateCaptionsHeight($slider);
      }, 500));
    });
  });

  function updateCaptionsHeight($slider) {
    var $captions = $slider.find('.image-caption');
    if($captions.length > 0) {
      var height = 0;
      $captions.each(function() {
        var _height = $(this).height();
        if(_height > height) {
          height = _height;
        }
      });
      $captions.css('height', height);
    }
  }
})(jQuery);
